import React from "react"
import Card from "@mui/material/Card"
import Box from "@mui/material/Box"
import Divider from "@mui/material/Divider"

import MDTypography from "components/MDTypography"
import moment from "moment"

const formatDate = (value) => {
  if (!value) return "-"
  return moment(value).format("DD/MM/YYYY")
}

const getStatusColor = (status) => {
  const normalized = String(status || "").toLowerCase()
  if (normalized === "approved") return { bg: "#E8F9EE", text: "#4CAF50" }
  if (normalized === "rejected") return { bg: "#FDEAEA", text: "#F44336" }
  if (normalized === "draft") return { bg: "#F5F5F5", text: "#6B7280" }
  return { bg: "#E3F2FD", text: "#1A73E8" }
}

function TeacherLeaveHistory({
  remainingLeaveDays,
  totalLeaveDaysTaken,
  mostRecent,
}) {
  const remaining = remainingLeaveDays ?? "-"
  const totalTaken = totalLeaveDaysTaken ?? "-"
  const status = mostRecent?.status || "-"
  const colors = getStatusColor(status)

  return (
    <Card
      sx={{
        p: 3,
        borderRadius: 0,
        boxShadow: "none",
      }}
    >
      <MDTypography
        variant="h6"
        fontWeight="bold"
        sx={{ mb: 2, color: "#344767" }}
      >
        2. Staff&apos;s Leave History
      </MDTypography>

      <Box sx={{ display: "flex", alignItems: "center", mb: 1.25 }}>
        <MDTypography variant="button" sx={{ minWidth: 170, color: "#344767" }}>
          Remaining Leave Days:
        </MDTypography>
        <MDTypography
          variant="button"
          fontWeight="bold"
          sx={{ color: "#344767" }}
        >
          {remaining} {remaining === "-" ? "" : "days"}
        </MDTypography>
      </Box>

      <Box sx={{ display: "flex", alignItems: "center", mb: 1.5 }}>
        <MDTypography
          variant="button"
          sx={{
            minWidth: 170,
          }}
        >
          Total Leave Days Taken:
        </MDTypography>
        <MDTypography
          variant="button"
          fontWeight="bold"
          sx={{ color: "#344767" }}
        >
          {totalTaken} {totalTaken === "-" ? "" : "days"}
        </MDTypography>
      </Box>

      <Box sx={{ mb: 1 }}>
        <MDTypography
          variant="button"
          // fontWeight="medium"
          sx={{ color: "#344767" }}
        >
          Most Recent Leave History:
        </MDTypography>
      </Box>

      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          flexWrap: "wrap",
          gap: 0.75,
        }}
      >
        <MDTypography variant="button" sx={{ color: "#344767" }}>
          Start date:
        </MDTypography>

        <MDTypography
          variant="button"
          fontWeight="bold"
          sx={{ color: "#344767" }}
        >
          {formatDate(mostRecent?.startDate)}
        </MDTypography>

        <MDTypography variant="button" sx={{ color: "#344767" }}>
          -
        </MDTypography>

        <MDTypography variant="button" sx={{ color: "#344767" }}>
          End date:
        </MDTypography>

        <MDTypography
          variant="button"
          fontWeight="bold"
          sx={{ color: "#344767" }}
        >
          {formatDate(mostRecent?.endDate)}
        </MDTypography>

        <MDTypography variant="button" sx={{ color: "#344767" }}>
          -
        </MDTypography>

        <MDTypography variant="button" sx={{ color: "#344767" }}>
          Status:
        </MDTypography>

        <Box
          sx={{
            px: 1,
            py: "2px",
            borderRadius: "6px",
            backgroundColor: colors.bg,
            display: "inline-flex",
            alignItems: "center",
          }}
        >
          <MDTypography
            variant="caption"
            fontWeight="medium"
            sx={{ color: colors.text, lineHeight: 1.6 }}
          >
            {status}
          </MDTypography>
        </Box>
      </Box>
    </Card>
  )
}

export default TeacherLeaveHistory
